import React from "react";
import ReactLoader from "react-js-loader";

const FavLoader = ({ style }) => {
  const Style = style ? style : {};
  return (
    <div className="hart_loader_container" style={{ ...Style }}>
      <ReactLoader type="heart" bgColor={"#1D7E7C"} size={40} />
    </div>
  );
};

export default FavLoader;
